import { render, staticRenderFns } from "./StartupHorizontalCard.vue?vue&type=template&id=47b3268a&"
import script from "./StartupHorizontalCard.vue?vue&type=script&lang=js&"
export * from "./StartupHorizontalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports